const isNil = (
  value: string | number | null | boolean | undefined | Array<unknown>
) => {
  return value === null || value === undefined;
};

export { isNil };
